'use client'

import React from 'react'

import { ColorKeysWithoutGradient, SpaceProps, Theme } from '../../themes'
import { GradientBoxBase } from './styles'

interface BaseGradientBoxProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Background color
   */
  bgColor?: ColorKeysWithoutGradient<Theme>

  /**
   * Align items
   */
  alignItems?: 'flex-start' | 'flex-end' | 'center'

  /**
   * Justify content
   */
  justifyContent?: 'flex-start' | 'flex-end' | 'center'

  /**
   * Click handler
   */
  onClick?: () => void

  /**
   * Box content
   */
  children: React.ReactNode

  /**
   * Neutral border color
   */
  isNeutral?: boolean
}

export type GradientBoxProps = BaseGradientBoxProps & SpaceProps

export const GradientBox = ({
  className,
  children,
  bgColor = 'white',
  p = 4,
  isNeutral = false,
  ...rest
}: GradientBoxProps) => {
  return (
    <GradientBoxBase
      className={className}
      bgColor={bgColor}
      p={p}
      isNeutral={isNeutral}
      {...rest}
    >
      {children}
    </GradientBoxBase>
  )
}
